import type {
  DeliveryConfigPropsMappedFromDispatch,
  DeliveryConfigPropsMappedFromState
} from '@console/containers/projectDraft/DeliveryConfigContainer';
import GiftCardDeliveryConfigContainer from '@console/containers/projectDraft/deliveryConfig/GiftCardDeliveryConfigContainer';
import GifteeBoxDeliveryConfigContainer from '@console/containers/projectDraft/deliveryConfig/GifteeBoxDeliveryConfigContainer';
import Grid from '@mui/material/Grid';
import type { StyleRules, WithStyles } from '@mui/styles';
import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

const styles = (): StyleRules => createStyles({});

type DeliveryConfigProps = DeliveryConfigPropsMappedFromState &
  DeliveryConfigPropsMappedFromDispatch &
  WithStyles<typeof styles>;

const DeliveryConfig: React.FC<DeliveryConfigProps> = ({
  isGifteeBoxGiftConfig,
  isFixedGiftConfig,
  isChoosableGiftConfig
}) => (
  <Grid container justifyContent="flex-start" alignItems="flex-start">
    {isGifteeBoxGiftConfig ? (
      <GifteeBoxDeliveryConfigContainer />
    ) : isFixedGiftConfig || isChoosableGiftConfig ? (
      <GiftCardDeliveryConfigContainer />
    ) : null}
  </Grid>
);

export default withStyles(styles)(DeliveryConfig);
